// Detail content for each of the 8 services on the Services step trail.
// Each entry: full content for /service/:slug page.

export const SERVICES = {
  "test-coaching": {
    slug: "test-coaching",
    n: "01",
    t: "Test Coaching",
    icon: "BookOpen",
    tagline: "Crack the test. Then the campus.",
    intro: "GRE, GMAT, IELTS, TOEFL, PTE, Duolingo — six big tests, one in-house academy. Live classes by educators who themselves score in the top percentile.",
    metaTitle: "Test Coaching — GRE · GMAT · IELTS · TOEFL · PTE · DET in Nagpur | Shah Overseas",
    metaDesc: "Live classes for GRE, GMAT, IELTS, TOEFL, PTE & Duolingo at Shah Overseas Academy in Nagpur. Top-percentile faculty, mock tests, score-boost guarantee.",
    routeHint: "/test-prep",
    helpPoints: [
      { title: "Diagnostic Test", desc: "Free 90-min mock to expose your real strengths and gaps before we spend a single rupee on coaching." },
      { title: "Customised Study Plan", desc: "Topic-by-topic plan based on your target score, target intake, and 4-/8-/12-week prep window." },
      { title: "Top-Percentile Faculty", desc: "GRE 335+, GMAT 760+, IELTS 8.5 educators teaching small batches (≤15 students)." },
      { title: "Mock Tests + Analytics", desc: "Weekly full-length mocks with section-wise analytics — see exactly where you're losing points." },
      { title: "Doubt Sessions On-Demand", desc: "1:1 doubt-clearing sessions and recorded class replays included throughout your prep." },
      { title: "Score Guarantee", desc: "Hit our published target score or repeat the program free of cost." },
    ],
  },
  "course-selection": {
    slug: "course-selection",
    n: "02",
    t: "Course Selection",
    icon: "GraduationCap",
    tagline: "Pick the course you'll thank yourself for in 5 years.",
    intro: "Fitting your career goal — not a sales target. We map your background and ambition to the program that compounds your career, not just your transcript.",
    metaTitle: "Study Abroad Course Selection — Personalised Counselling | Shah Overseas",
    metaDesc: "Career-mapped course selection for studying abroad. MS, MBA, Bachelor's, PhD — picked with you, not for you. Free 30-min profile review.",
    helpPoints: [
      { title: "60-min Career Mapping", desc: "Deep-dive call to map your interests, strengths, finances, and 5-year career trajectory." },
      { title: "STEM vs Non-STEM Trade-offs", desc: "We break down OPT, work visa, salary impact for each program type — in numbers, not vibes." },
      { title: "MS vs MBA vs PhD Decision", desc: "Honest counselling on which degree actually delivers ROI for your background." },
      { title: "Specialisation Shortlist", desc: "Narrow 100s of programs to a 5-tier specialisation map — best fit, ROI, employability." },
      { title: "Industry Mentor Connect", desc: "Speak with 2-3 alumni working in your target field before locking in your decision." },
      { title: "Reversible Pivot Plan", desc: "Backup plan + pivot strategy in case admit cycle doesn't go your way." },
    ],
  },
  "profile-building": {
    slug: "profile-building",
    n: "03",
    t: "Profile Building",
    icon: "UserCheck",
    tagline: "Make admission committees say yes the first time.",
    intro: "Profile-building isn't padding your resume with fluff — it's becoming the candidate the admissions committee was already looking for. Strategic, surgical, on-brand.",
    metaTitle: "Profile Building for Study Abroad Admissions | Shah Overseas Education",
    metaDesc: "Strategic profile building for top university admissions abroad. Internships, research, certifications, leadership — what really moves the needle.",
    helpPoints: [
      { title: "Profile Audit", desc: "Side-by-side comparison with admits at your target programs — see your real gaps." },
      { title: "12-Week Portfolio Plan", desc: "Custom roadmap of projects, certifications, internships, research, and extracurriculars." },
      { title: "Research/Internship Connect", desc: "Curated list of online research positions, hackathons, and remote internships you can land in 4-8 weeks." },
      { title: "GitHub / LinkedIn / Portfolio", desc: "Help you build a public-facing portfolio site & LinkedIn that signals 'admit-worthy' immediately." },
      { title: "Soft-skill Storytelling", desc: "Surface the leadership, team-building, and impact stories already in your background." },
      { title: "Quarterly Review", desc: "90-day reviews to keep momentum & adjust based on application cycle progress." },
    ],
  },
  "university-shortlist": {
    slug: "university-shortlist",
    n: "04",
    t: "University Shortlist",
    icon: "Award",
    tagline: "Smart shortlists. Cleaner applications. Higher admit rates.",
    intro: "We don't pick 30 random universities and pray. We craft a 6-12 university list — Reach, Match, Safety — using your real profile, your real budget, and our real outcome data.",
    metaTitle: "University Shortlisting for Indian Students Abroad | Shah Overseas",
    metaDesc: "Data-driven university shortlisting for studying abroad. Reach / Match / Safety mix calibrated to your GPA, test scores, and budget. Higher admit success.",
    helpPoints: [
      { title: "Reach / Match / Safety Mix", desc: "Statistically calibrated 3-tier shortlist using SOE's 15K+ admit dataset, not Reddit threads." },
      { title: "Course-First Filtering", desc: "We filter by program quality, faculty research fit, and post-grad placement — not USNews ranking alone." },
      { title: "Budget-Locked Filtering", desc: "Every uni in your list aligns with your tuition + living budget after scholarships." },
      { title: "Geographic Strategy", desc: "Visa-friendly states/cities, climate fit, weekend-trip distance from family/friends abroad." },
      { title: "Faculty Match Score", desc: "Map your interests to specific professors at each uni — strengthens SOPs immediately." },
      { title: "Application Calendar", desc: "Master spreadsheet with deadlines, fee waivers, requirements, status — all in one place." },
    ],
  },
  "document-design": {
    slug: "document-design",
    n: "05",
    t: "Document Design",
    icon: "FileSignature",
    tagline: "SOPs, LORs, resumes — crafted to actually convert.",
    intro: "Your documents have 3 minutes to sell you. We make those 3 minutes count. No templates. No clichés. Voice-first, story-driven, evidence-backed.",
    metaTitle: "SOP, LOR & Resume Writing for Study Abroad | Shah Overseas Education",
    metaDesc: "Professional SOP, LOR, and resume writing service for top university admissions abroad. Voice-first, story-driven, no templates.",
    helpPoints: [
      { title: "1:1 Story Interview", desc: "90-min recorded interview to surface the real you — stories, motivations, defining moments." },
      { title: "Custom SOP per University", desc: "Each SOP is rewritten to address that uni's program, faculty, and culture — never recycled." },
      { title: "LOR Strategy + Drafts", desc: "Pick the right recommenders. Draft talking points for them. Polish their final letters for impact." },
      { title: "ATS-Optimised Resume", desc: "1-page academic CV that passes every ATS and still feels human at the committee read." },
      { title: "Visual Portfolio (Design/Tech)", desc: "For design / CS / arts majors: a portfolio site that shows your work, not just your words." },
      { title: "Editor's Final Pass", desc: "Two senior editors review every document for tone, grammar, redundancy, and impact." },
    ],
  },
  "scholarship-loan": {
    slug: "scholarship-loan",
    n: "06",
    t: "Scholarship & Loan",
    icon: "Wallet",
    tagline: "Maximise scholarships. Minimise loan stress.",
    intro: "Studying abroad shouldn't put your family in debt forever. We hunt for every scholarship you qualify for, then engineer your loan to the lowest sustainable EMI.",
    metaTitle: "Scholarships & Education Loan for Study Abroad | Shah Overseas",
    metaDesc: "Scholarship hunting + education loan assistance for Indian students studying abroad. $1M+ scholarships unlocked for our students annually.",
    helpPoints: [
      { title: "Scholarship Database", desc: "Curated list of 200+ scholarships filtered to your profile, target country, and target program." },
      { title: "Application Drafting", desc: "We draft your scholarship essays — same voice-first quality as your SOPs." },
      { title: "External Funding Hunt", desc: "Research grants, ASCA, GREAT, DAAD, Erasmus, country-specific awards — full hunt by our team." },
      { title: "Education Loan Comparison", desc: "Compare ICICI, HDFC Credila, SBI, Avanse, Prodigy across interest rate, EMI, processing fees." },
      { title: "Co-applicant Strategy", desc: "Help structure parents' financials to maximise loan-eligibility without over-leveraging." },
      { title: "Forex & Tuition Wire", desc: "Lowest-FX-margin remittance partner intros + GIC processing for Canada applicants." },
    ],
  },
  "visa-counselling": {
    slug: "visa-counselling",
    n: "07",
    t: "Visa Counselling",
    icon: "Stamp",
    tagline: "Embassy interview prep, documentation, mock sessions.",
    intro: "Visa rejection at the last mile is the cruellest outcome — and the most preventable. We rehearse with you 4+ times until 'No?' becomes impossible to say.",
    metaTitle: "Student Visa Counselling — F-1, Tier 4, SDS, Subclass 500 | Shah Overseas",
    metaDesc: "End-to-end student visa counselling for USA, UK, Canada, Australia, Ireland & Europe. Mock interviews, financial doc review, 95% approval rate.",
    helpPoints: [
      { title: "Document Audit", desc: "Triple-check every required document — bank statements, sponsor letters, fund proof — for embassy red flags." },
      { title: "Country-Specific Briefing", desc: "Visa rules for USA F-1, UK Student Route, Canada SDS, Australia Subclass 500 — all fully briefed." },
      { title: "4+ Mock Interviews", desc: "Recorded mock interviews with senior counsellors who've handled real embassy questions." },
      { title: "Financial Storytelling", desc: "Frame your family's financial profile in a way that's truthful AND visa-officer-friendly." },
      { title: "DS-160 / CAS / GS Statements", desc: "Personalised statements written to clear genuine-student / non-immigrant intent flags." },
      { title: "Day-of-Interview Coach", desc: "WhatsApp/phone support on visa day — last-minute confidence boosts and answers." },
    ],
  },
  "pre-departure": {
    slug: "pre-departure",
    n: "08",
    t: "Pre-Departure",
    icon: "Plane",
    tagline: "Land in your new country already feeling at home.",
    intro: "From SIM cards to bank accounts to roommate matching — the small stuff that breaks new students. We handle it all so you can focus on showing up.",
    metaTitle: "Pre-Departure Briefing for Study Abroad Students | Shah Overseas",
    metaDesc: "Comprehensive pre-departure orientation: housing, banking, packing, culture, weather, alumni network introductions.",
    helpPoints: [
      { title: "Pre-Departure Workshop", desc: "Full-day workshop covering culture, weather, housing, banking, transport — with city-specific tips." },
      { title: "Housing & Roommate Match", desc: "Verified rental partners + matchmaking with other SOE alumni heading to the same city." },
      { title: "Banking & SIM Setup", desc: "Step-by-step on opening student bank account, getting SIM, US/UK credit history kickstart." },
      { title: "Smart Packing Guide", desc: "Country-specific packing list — what to bring, what to buy abroad, baggage limits." },
      { title: "Alumni City Buddy", desc: "Get connected with a senior SOE alumni in your destination city for 1:1 onboarding." },
      { title: "First-Month Crisis Hotline", desc: "Stuck on housing, courses, classes? Our team is your safety net for the first 30 days abroad." },
    ],
  },
};

export const SERVICES_LIST = Object.values(SERVICES);
